import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Students from "../components/structureComponent/studentsComponent";
import Footer from "../components/footerComponent/footer";

export default function StudentsPage() {
    return (
        <Layout>
            <Header/>
            <Students/>
            <Footer/>
        </Layout>
    );
}
